<div class="dot-circle">
    <div class="effect-circle"></div>
    <div class="main-circle">
        <div class="circle-bg">
            <img src="{{image}}" alt="fancybox">
        </div>
    </div>
</div>
<h4 class="mb-2">{{title}}</h4>
<p>{{text}}</p>